import React from "react";
import BaseLayout from "../../components/BaseLayout/BaseLayout";
import InputSearch from "../../components/InputSearch/InputSearch";
import { AntTab, AntTabs } from "../../components/TabPanel/TabPanel";
import {
  Grid,
  Paper,
  makeStyles,
  createStyles,
  Button,
} from "@material-ui/core";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  IconButton,
} from "@material-ui/core";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";

import Link from "@material-ui/core/Link";
import { showDetail } from "./Container/DetailVoucherOrder";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../components/CustomStyles/CustomTable";
import {
  StyledPaperTabs,
  StyledTab,
} from "../../components/CustomStyles/CustomTabs";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      width: "100%",
    },
    button: {
      margin: 0,
      maxHeight: 30,
      padding: 1,
    },
    paper: {
      padding: 8,
      width: 290,
    },
    demo1: {
      backgroundColor: theme.palette.background.paper,
      marginBottom: 10,
    },
    fab: {
      position: "fixed",
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    },
    card: {
      margin: 5,
      width: "300px",
    },
    cardTitle: {
      color: theme.palette.primary.dark,
      fontWeight: "bolder",
    },
    cardSubHeader: {
      fontSize: "smaller",
    },
  })
);

const ListVoucherOrder = () => {
  return (
    <StyledTableRow>
      <StyledTableCell>1</StyledTableCell>
      <StyledTableCell>
        <Typography style={{ color: "#2196F3", fontSize: 13 }}>
          Voucher KFC Rp 100.000
        </Typography>
      </StyledTableCell>

      <StyledTableCell>
        <Button
          variant="contained"
          style={{
            backgroundColor: "#2196F3",
            color: "white",
            borderRadius: "0",
            fontSize: "12px",
          }}
        >
          New Request
        </Button>
      </StyledTableCell>
      <StyledTableCell>
        <Typography style={{ color: "#212121", fontSize: 13 }}>
          hesa@izy.ai
        </Typography>
      </StyledTableCell>

      <StyledTableCell>30 - 12 - 2020 | 13:00 PM</StyledTableCell>

      <StyledTableCell align="right">
        <IconButton
          color="secondary"
          aria-label="detail voucher"
          onClick={showDetail}
        >
          <ArrowForwardIcon />
        </IconButton>
      </StyledTableCell>
    </StyledTableRow>
  );
};

const VoucherOrder = () => {
  const classes = useStyles();
  const [tabActive, setTabActive] = React.useState(0);
  // const prevTabActive = usePreviousTab(tabActive);

  let arrProcess = [
    { status: "all", label: "All" },
    {
      status: "new",
      label: "New Request",
      status_action: "process",
      label_action: "Process Order",
      message_action: "Are you sure to Process this order now ?",
    },
    {
      status: "process",
      label: "On Process",
      status_action: "ready",
      label_action: "QR For Pickup",
      message_action: "a",
    },
    { status: "complete", label: "Complete" },
  ];

  const handleTabChange = (event, newTab) => {
    // setExpanded(false);
    setTabActive(newTab);
  };

  return (
    <BaseLayout>
      <Grid container className={classes.root}>
        <Grid item xs={12}>
          <h3>Voucher / Voucher List</h3>
        </Grid>
      </Grid>

      <Grid container className={classes.root}>
        <Grid
          item
          container
          direction="row"
          alignItems="flex-start"
          justify="space-between"
          xs={12}
        >
          <InputSearch
            // value={search}
            // onChange={(e) => {
            //     handleSearch(e);
            // }}
            placeholder="Search"
          />
        </Grid>

        <Grid item xs={12}>
          <StyledPaperTabs square>
            <AntTabs
              value={tabActive}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
            >
              {arrProcess.map((process, index) => {
                return <AntTab key={index} label={process.label}></AntTab>;
              })}
            </AntTabs>
          </StyledPaperTabs>
        </Grid>
      </Grid>

      <Grid container className={classes.root}>
        <Grid item xs={12}>
          <TableContainer>
            <Table style={{ minWidth: 690 }}>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell align="left" width="5%">
                    #
                  </StyledTableCell>
                  <StyledTableCell align="left" width="25%">
                    Voucher Name
                  </StyledTableCell>
                  <StyledTableCell align="left" width="20%">
                    Status
                  </StyledTableCell>
                  <StyledTableCell align="left" width="20%">
                    Buyer
                  </StyledTableCell>
                  <StyledTableCell align="left" width="20%">
                    Date
                  </StyledTableCell>
                  <StyledTableCell align="left" width="10%"></StyledTableCell>
                  {/* <StyledTableCell></StyledTableCell> */}
                </StyledTableRow>
              </TableHead>
              <TableBody>
                <ListVoucherOrder />
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </BaseLayout>
  );
};

export default VoucherOrder;
